import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { Header2, ParagraphS } from '../../core/Typography/Typography';

export const Wrapper = styled.section`
  position: relative;
  ${defaultContainerSize};
  margin: 0;
  max-width: 100%;

  background: ${({ theme }) => theme.colors.light_grey};
  padding-top: 4rem;
  padding-bottom: 4rem;

  ${mq.xLarge(css`
    padding-bottom: 7.5rem;
    padding-top: 7.5rem;
  `)};
`;

export const Inner = styled.div`
  width: 100%;
  max-width: 77.125rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  ${mq.large(css`
    flex-direction: row;
  `)};
`;

export const About = styled.div`
  width: 100%;
  margin-bottom: 4rem;

  ${mq.large(css`
    width: 50%;
    margin-bottom: 0;
    margin-right: 3.5rem;
  `)};

  ${mq.xLarge(css`
    margin-right: 9rem;
  `)};
`;

export const AboutSticky = styled.div`
  ${mq.large(css`
    top: 0;
    position: sticky;
    padding-top: 4rem;
  `)};

  ${mq.xLarge(css`
    padding-top: 7.5rem;
  `)};
`;

export const Title = styled.h3`
  ${Header2};
  margin: 0 0 1.5rem 0;

  ${mq.xLarge(css`
    margin-bottom: 1.5rem;
  `)};
`;

export const SpanTitle1 = styled.span`
  color: ${({ theme }) => theme.colors.primary};
`;

export const SpanTitle2 = styled.span`
  color: ${({ theme }) => theme.colors.core_black};
`;

export const Description = styled.p`
  ${ParagraphS};
  color: ${({ theme }) => theme.colors.core_black};
  letter-spacing: 0.0125rem;
  margin: 0;
`;

export const Cards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq.large(css`
    width: 50%;
    align-items: flex-start;
  `)};
`;
